module.exports = __webpack_public_path__ + "static/media/more.42fec6a7.svg";